import React, { useState, useEffect } from "react"
import TextField from "../components/textField"
import commentService from "../services/comment.service"
import dictionary from "../utils/dictionary"
import { useSelector } from "react-redux"

const MAP_EMBED_URL =
  "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2808.5028863857437!2d19.8165161!3d45.2578443!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa6f9afb04fe10bcf%3A0xc9f12d38c0298a98!2sTimeless%20beauty!5e0!3m2!1sen!2sru!4v1694069813400!5m2!1sen!2sru"

const SALON_ADDRESS = "Илије Бирчанина 29, Нови Сад, Новис Сад 21000, Serbia"
const SALON_PHONE = "+381693005555"

const FeedbackLocation = ({ mapClassName, showMap }) => (
  <div className="p-[20px] max-md:p-[5px]">
    {showMap ? (
      <iframe
        title="googleMaps"
        src={MAP_EMBED_URL}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        className={mapClassName}
        allowFullScreen
      />
    ) : (
      <div
        className={`${mapClassName} bg-lightGray animate-pulse`}
        aria-hidden="true"
      />
    )}
    <p className="mb-[20px]">{SALON_ADDRESS}</p>
    <a className="hover:opacity-80" href={`tel:${SALON_PHONE}`}>
      {SALON_PHONE}
    </a>
  </div>
)

const FeedbackForm = ({
  selectedLanguage,
  handleChange,
  handleSubmit,
  nameLabel,
}) => (
  <div className="p-[20px] max-md:p-[5px]">
    <TextField
      name="name"
      label={nameLabel}
      placeholder={dictionary[selectedLanguage].yourName}
      type="text"
      onChange={handleChange}
    />
    <TextField
      name="email"
      label="E-mail"
      placeholder="E-mail"
      type="email"
      onChange={handleChange}
    />
    <TextField
      name="content"
      label={dictionary[selectedLanguage].message}
      placeholder=""
      type="text"
      onChange={handleChange}
      area={true}
    />
    <div className="flex justify-end">
      <button
        onClick={handleSubmit}
        className="bg-brown rounded-lg text-white text-center w-[50%] py-[8px] mt-[24px] hover:opacity-80"
      >
        {dictionary[selectedLanguage].confirm}
      </button>
    </div>
  </div>
)

const FeedbackPage = () => {
  const selectedLanguage = useSelector((state) => state.lang.lang)
  const [showMap, setShowMap] = useState(false)
  const [data, setData] = useState({
    name: "",
    email: "",
    content: "",
  })

  const handleChange = (target) => {
    setData((prevState) => ({
      ...prevState,
      [target.name]: target.value,
    }))
  }

  const handleSubmit = async () => {
    await commentService.createFeedback(data.name, data.email, data.content)
  }

  useEffect(() => {
    setShowMap(true)
  }, [])

  const windowWidth = window.innerWidth
  const mapClassName =
    "w-full rounded-2xl mb-[20px] border-0 min-h-[320px] h-[50vh] max-md:h-[320px]"

  return (
    <div className="container-fluid relative mx-auto min-h-screen flex justify-center items-start bg-cream text-brown">
      {windowWidth > 400 ? (
        <div className="grid grid-cols-2 w-full mx-auto max-w-[1496px]">
          <FeedbackLocation mapClassName={mapClassName} showMap={showMap} />
          <FeedbackForm
            selectedLanguage={selectedLanguage}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            nameLabel="Имя"
          />
        </div>
      ) : (
        <div className="w-full mx-auto max-w-[1496px]">
          <FeedbackForm
            selectedLanguage={selectedLanguage}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            nameLabel={dictionary[selectedLanguage].yourName}
          />
          <FeedbackLocation mapClassName={mapClassName} showMap={showMap} />
        </div>
      )}
    </div>
  )
}

export default FeedbackPage
